<aran-page-title
  [headerConfig]="{
    bannerTitle: appInfo.appName + ' | ' + routeMetaData.requests.title
  }"
  [buttonConfig]="{
    isVisibleButton: true,
    buttonName: 'Create New',
    icon: 'add_circle',
    handleClick: openDialog
  }"
></aran-page-title>

<div class="requests-container">
  <div class="table-container">
    <div class="mt-8 mb-4">
      <aran-filter
        *ngIf="dataSource.length > 0"
        [templateRef]="filterTemplate"
        [isSearchButtonVisible]="false"
        (resetFilter)="resetFilter()"
        [translations]="{
          filterTitle: 'Filter',
        }"
      ></aran-filter>

      <ng-template #filterTemplate>
        <div class="flex w-[40%]">
          <aran-input
            class="w-full"
            [type]="'text'"
            [label]="'Search'"
            [outline]="false"
            [formControl]="searchText"
          ></aran-input>
        </div>
      </ng-template>
    </div>

    <aran-table
      *ngIf="!(isLoading$ | async)"
      [columns]="columns"
      [data]="dataSource"
      [menu]="actionMenuComponent.menu"
      [sort]="{
        clientSide: true
      }"
      [translations]="{
          noDataText: 'No information found',
          }"
      [pagination]="{
        clientSide: true,
        currentPage: currentPage,
        itemsPerPage: itemsPerPage,
        totalItems: dataSource.length,
        footerTablePagination: false
      }"
      [filter]="[{ filteredText: searchText.value || '' }]"
      (onSelectRow)="onSelectRow($event)"
    ></aran-table>

    <aran-menu #actionMenuComponent [menuItems]="menuItems"></aran-menu>
  </div>

  <ng-container>
    <ng-template #createNewRequest>
      <app-create></app-create>
    </ng-template>

    <ng-template #updateRequest>
      <app-update
        [requestId$]="selectedElement.id ?? 0"
        targetPage="main"
      ></app-update>
    </ng-template>

    <aran-drawer-modal
      *ngIf="currentTemplate"
      [isDrawerOpen]="false"
      [templateRef]="currentTemplate"
      [modalTitle]="modalTitle"
    ></aran-drawer-modal>
  </ng-container>
</div>

<ng-template #statusTemplate let-row>
  <span [ngStyle]="{ color: getStatusColor(row.status) }">
    {{ row.status }}
  </span>
</ng-template>
